var _path, _mask, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteinGelElectrophoresisBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 207,
    viewBox: "0 0 176 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67784 91.6851H173.162L173.094 92.7016L173.162 92.646L165.592 207H141.936L139.056 191.404H39.783L36.9035 207H13.2476L5.67773 92.646L5.74538 92.7018L5.67784 91.6851Z",
    fill: "#F2F2F2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 91,
    width: 169,
    height: 117
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67773 91.6851H173.162L172.769 92.9703L173.162 92.646L165.592 207H141.936L138.358 187.623H40.481L36.9035 207H13.2476L5.67773 92.646L5.82749 92.7696L5.67773 91.6851Z",
    fill: "#F2F2F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M79.957 95.5288L26.9678 203.156L59.1398 207.961L114.495 95.5288H79.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M119.226 95.5288L63.3984 208.922H68.6027L124.431 95.5288H119.226Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8174 91.6851H26.4948V179.176C26.4948 180.744 25.2239 182.015 23.6561 182.015V182.015C22.0883 182.015 20.8174 180.744 20.8174 179.176V91.6851Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.345 91.6851H158.022V179.176C158.022 180.744 156.751 182.015 155.183 182.015V182.015C153.616 182.015 152.345 180.744 152.345 179.176V91.6851Z",
    fill: "#AD210C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.097 191.467L141.936 207H165.592L173.162 92.646L173.086 92.7084L173.162 91.6851H5.67773L5.78073 92.731L5.67773 92.646L13.2476 207H36.9035L39.8501 191.467H139.097ZM35.5921 203.156L38.5386 187.623H140.409L143.247 203.156H163.937L170.851 98.7014L170.722 98.8081L170.964 95.5289H7.98618L8.32602 98.9801L7.98808 98.7013L14.9027 203.156H35.5921Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.0229 179.589H130.839L140.043 185.261H38.7959L49.0229 179.589Z",
    fill: "#F2F2F2",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.1943 195.469H38.7965L37.3771 203.156H15.1406L14.1943 195.469Z",
    fill: "#F2F2F2",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M164.646 195.469H140.043L141.463 203.156H163.699L164.646 195.469Z",
    fill: "#F2F2F2",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4945 65.2192H20.8171V73.3311C18.0429 74.4541 16.0859 77.1739 16.0859 80.3508V89.7946H31.2257V80.3508C31.2257 77.1739 29.2687 74.4541 26.4945 73.3311V65.2192Z",
    fill: "#444444"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.495 65.2192H24.6025V73.6703C24.6025 73.6703 24.6025 73.6704 24.6025 73.6704V73.7261H24.6649C24.8051 73.8514 24.944 73.9742 25.0812 74.0954C26.8871 75.691 28.3875 77.0166 28.3875 80.3425V89.7946H31.2262V80.3425C31.2262 77.1691 29.2692 74.4523 26.495 73.3305V65.2192Z",
    fill: "#111111"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7637 65.2192H22.71V73.7261H22.7073C22.7082 73.7261 22.7091 73.7261 22.71 73.7261C22.1991 74.2364 21.7324 74.6401 21.3145 75.0015C19.7975 76.3137 18.925 77.0684 18.925 80.3427V89.7948H17.0326V80.3427C17.0326 77.1693 18.9895 74.4525 21.7637 73.3307V65.2192Z",
    fill: "#999999"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.022 65.2192H152.344V73.3311C149.57 74.4541 147.613 77.1739 147.613 80.3508V89.7946H162.753V80.3508C162.753 77.1739 160.796 74.4541 158.022 73.3311V65.2192Z",
    fill: "#AD210C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.022 65.2192H156.13V73.6703C156.13 73.6703 156.13 73.6704 156.13 73.6704V73.7261H156.192C156.332 73.8514 156.471 73.9742 156.609 74.0954C158.414 75.691 159.915 77.0166 159.915 80.3425V89.7946H162.754V80.3425C162.754 77.1691 160.797 74.4523 158.022 73.3305V65.2192Z",
    fill: "#541005"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.291 65.2192H154.237V73.7261H154.235C154.236 73.7261 154.236 73.7261 154.237 73.7261C153.726 74.2364 153.26 74.6401 152.842 75.0015C151.325 76.3137 150.452 77.0684 150.452 80.3427V89.7948H148.56V80.3427C148.56 77.1693 150.517 74.4525 153.291 73.3307V65.2192Z",
    fill: "#C48686"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 91.4692C0 90.3647 0.895431 89.4692 2 89.4692H174C175.105 89.4692 176 90.3647 176 91.4692V99.6439C176 105.167 171.523 109.644 166 109.644H10C4.47715 109.644 0 105.167 0 99.6439V91.4692Z",
    fill: "#F2F2F2",
    fillOpacity: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2 90.4692H174C174.552 90.4692 175 90.917 175 91.4692V99.6439C175 104.615 170.971 108.644 166 108.644H10C5.02944 108.644 1 104.615 1 99.6439V91.4692C1 90.917 1.44772 90.4692 2 90.4692Z",
    stroke: "#F2F2F2",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinGelElectrophoresisBox);
export default __webpack_public_path__ + "static/media/Protein_Gel_Electrophoresis_Box.6c3b997ca14269325d9e7d772eeeb087.svg";
export { ForwardRef as ReactComponent };